<template>
  <div>
    <Modal title="Detail" :open.sync="showDetailModal" size="sm:max-w-3xl">
      <div class="p-6" style="height:30rem;">
        <mgl-map class="w-full h-full"
          ref="mapbox"
          :center="coords[45]" 
          :access-token="accessToken"
          :map-style="mapStyle"
          :zoom="zoom"
          :attribution-control="false">
          <mgl-navigation-control />
          <mgl-marker v-for="coord in coords" :key="coord.latitude + coord.longitude" :coordinates="coord" anchor="bottom">
            <div slot="marker">
              <div class="flex items-center justify-center w-6 h-6 bg-pink-400 bg-opacity-25 rounded-full">
                <div class="w-3 h-3 bg-pink-400 rounded-full"></div>
              </div>
            </div>
          </mgl-marker>
        </mgl-map>
      </div>
    </Modal>

    <div class="flex p-6">
      <DatePicker class="mr-2" color="indigo" mode="dateTime" :minute-increment="5" is-range is24hr v-model="filter.date" :model-config="{ start: { timeAdjust: '00:00:00' }, end: { timeAdjust: '23:59:59' } }">
        <template v-slot="{ inputValue, inputEvents }">
          <div class="flex justify-center">
            <input
              :value="inputValue.start"
              v-on="inputEvents.start"
              class="w-40 form-input prepend"
            />
            <div class="flex items-center justify-center flex-none w-10 border bg-gray-50">
              &rarr;
            </div>
            <input
              :value="inputValue.end"
              v-on="inputEvents.end"
              class="w-40 form-input append"
            />
          </div>
        </template>
      </DatePicker>
      <button class="btn btn-secondary" v-submitting="$parent.submitting"  @click="$parent.pullReport(params)">
        Pull Report
      </button>
    </div>

    <template v-if="report">
      <div class="flex flex-col">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div class="overflow-hidden border-b border-gray-100">
              <table class="min-w-full divide-y divide-gray-100">
                <thead>
                  <tr>
                    <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-400 uppercase bg-gray-50">
                      Vehicle
                    </th>
                    <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-400 uppercase bg-gray-50">
                      Distance
                    </th>
                    <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-400 uppercase bg-gray-50">
                      Time
                    </th>
                    <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-400 uppercase bg-gray-50">
                      Speed
                    </th>
                    <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-400 uppercase bg-gray-50">
                      Input
                    </th>
                    <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-400 uppercase bg-gray-50">
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y">
                  <tr class="bg-white group" v-for="row in report.rows" :key="row.orderid">
                    <td class="px-6 py-4 text-sm font-medium leading-5 text-gray-900 whitespace-nowrap group-hover:bg-gray-50">
                      {{ row.objectname }} {{ row.objectno }}
                    </td>
                    <td class="px-6 py-4 text-sm leading-5 text-gray-900 whitespace-nowrap group-hover:bg-gray-50">
                      {{ row.distance / 100 }}m
                    </td>
                    <td class="px-6 py-4 text-sm leading-5 text-gray-900 whitespace-nowrap group-hover:bg-gray-50">
                      {{ row.duration }}s
                    </td>
                    <td class="px-6 py-4 text-sm leading-5 text-gray-900 whitespace-nowrap group-hover:bg-gray-50">
                      {{ ((row.distance / 100000) / (row.duration / 3600)).toFixed(2) }}km/h
                    </td>
                    <td class="px-6 py-4 text-sm leading-5 text-gray-900 whitespace-nowrap group-hover:bg-gray-50">
                      {{ row.reference }}
                    </td>
                    <td class="px-6 py-4 text-sm leading-5 text-right text-gray-900 whitespace-nowrap group-hover:bg-gray-50">
                      <button class="btn btn-secondary" @click="openDetailModal(row)">View Details</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { sub, formatDuration } from 'date-fns'
import { MglMap, MglMarker, MglNavigationControl } from 'vue-mapbox'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
  name: 'InputExceptionReport',

  components: {
    DatePicker,
    MglMap,
    MglMarker,
    MglNavigationControl,
  },

  props: {
    report: {
      type: Object
    }
  },

  computed: {
    coords () {
      return this.tracks.map((track) => [track.longitude / 1e6, track.latitude / 1e6])
    },

    params () {
      return {
        filter: this.filter
      }
    }
  },

  data () {
    return {
      filter: {
        date: {
          start: sub(new Date(), { days: 30 }),
          end: new Date()
        }
      },
      showDetailModal: false,
      accessToken: 'pk.eyJ1IjoiZmxlZXRiZWFjb24iLCJhIjoiY2puZXczdHhmMHFqeDNrbGZ3dGNmbGU2cCJ9.dZ0JMOD5222pAk-pR6wzYQ',
      mapStyle: 'mapbox://styles/mapbox/satellite-v9',
      zoom: 16,
      tracks: [
        {
          "pos_time": "2020-09-15T05:14:40Z",
          "receivetime": "2020-09-15T05:14:53Z",
          "latitude": -34044338,
          "longitude": 20548914,
          "speed": 0,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:14:43Z",
          "receivetime": "2020-09-15T05:14:53Z",
          "latitude": -34044337,
          "longitude": 20548892,
          "speed": 4,
          "course": 273,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:14:46Z",
          "receivetime": "2020-09-15T05:14:53Z",
          "latitude": -34044339,
          "longitude": 20548859,
          "speed": 4,
          "course": 261,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:14:49Z",
          "receivetime": "2020-09-15T05:14:53Z",
          "latitude": -34044348,
          "longitude": 20548824,
          "speed": 4,
          "course": 256,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:14:52Z",
          "receivetime": "2020-09-15T05:14:53Z",
          "latitude": -34044355,
          "longitude": 20548789,
          "speed": 4,
          "course": 258,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:14:55Z",
          "receivetime": "2020-09-15T05:15:08Z",
          "latitude": -34044361,
          "longitude": 20548755,
          "speed": 4,
          "course": 262,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:14:58Z",
          "receivetime": "2020-09-15T05:15:08Z",
          "latitude": -34044372,
          "longitude": 20548720,
          "speed": 4,
          "course": 255,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:15:01Z",
          "receivetime": "2020-09-15T05:15:08Z",
          "latitude": -34044383,
          "longitude": 20548685,
          "speed": 4,
          "course": 254,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:15:04Z",
          "receivetime": "2020-09-15T05:15:08Z",
          "latitude": -34044392,
          "longitude": 20548650,
          "speed": 4,
          "course": 254,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:15:07Z",
          "receivetime": "2020-09-15T05:15:08Z",
          "latitude": -34044405,
          "longitude": 20548612,
          "speed": 4,
          "course": 258,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:15:10Z",
          "receivetime": "2020-09-15T05:15:23Z",
          "latitude": -34044416,
          "longitude": 20548574,
          "speed": 4,
          "course": 257,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:15:13Z",
          "receivetime": "2020-09-15T05:15:23Z",
          "latitude": -34044422,
          "longitude": 20548540,
          "speed": 4,
          "course": 257,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:15:16Z",
          "receivetime": "2020-09-15T05:15:23Z",
          "latitude": -34044428,
          "longitude": 20548505,
          "speed": 4,
          "course": 258,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:15:19Z",
          "receivetime": "2020-09-15T05:15:23Z",
          "latitude": -34044433,
          "longitude": 20548469,
          "speed": 4,
          "course": 260,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:15:22Z",
          "receivetime": "2020-09-15T05:15:23Z",
          "latitude": -34044441,
          "longitude": 20548434,
          "speed": 4,
          "course": 254,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:15:25Z",
          "receivetime": "2020-09-15T05:15:38Z",
          "latitude": -34044445,
          "longitude": 20548398,
          "speed": 4,
          "course": 263,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:15:28Z",
          "receivetime": "2020-09-15T05:15:38Z",
          "latitude": -34044452,
          "longitude": 20548360,
          "speed": 4,
          "course": 260,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:15:31Z",
          "receivetime": "2020-09-15T05:15:38Z",
          "latitude": -34044461,
          "longitude": 20548323,
          "speed": 4,
          "course": 257,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:15:34Z",
          "receivetime": "2020-09-15T05:15:38Z",
          "latitude": -34044465,
          "longitude": 20548286,
          "speed": 4,
          "course": 262,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:15:37Z",
          "receivetime": "2020-09-15T05:15:38Z",
          "latitude": -34044465,
          "longitude": 20548253,
          "speed": 4,
          "course": 260,
          "odometer": 1816606
        },
        {
          "pos_time": "2020-09-15T05:15:40Z",
          "receivetime": "2020-09-15T05:15:53Z",
          "latitude": -34044465,
          "longitude": 20548220,
          "speed": 4,
          "course": 262,
          "odometer": 1816658
        },
        {
          "pos_time": "2020-09-15T05:15:43Z",
          "receivetime": "2020-09-15T05:15:53Z",
          "latitude": -34044471,
          "longitude": 20548184,
          "speed": 4,
          "course": 258,
          "odometer": 1816658
        },
        {
          "pos_time": "2020-09-15T05:15:46Z",
          "receivetime": "2020-09-15T05:15:53Z",
          "latitude": -34044487,
          "longitude": 20548145,
          "speed": 4,
          "course": 254,
          "odometer": 1816658
        },
        {
          "pos_time": "2020-09-15T05:15:49Z",
          "receivetime": "2020-09-15T05:15:53Z",
          "latitude": -34044501,
          "longitude": 20548114,
          "speed": 4,
          "course": 238,
          "odometer": 1816658
        },
        {
          "pos_time": "2020-09-15T05:15:52Z",
          "receivetime": "2020-09-15T05:15:53Z",
          "latitude": -34044508,
          "longitude": 20548082,
          "speed": 4,
          "course": 256,
          "odometer": 1816658
        },
        {
          "pos_time": "2020-09-15T05:15:55Z",
          "receivetime": "2020-09-15T05:16:08Z",
          "latitude": -34044515,
          "longitude": 20548047,
          "speed": 4,
          "course": 261,
          "odometer": 1816658
        },
        {
          "pos_time": "2020-09-15T05:15:58Z",
          "receivetime": "2020-09-15T05:16:08Z",
          "latitude": -34044529,
          "longitude": 20548011,
          "speed": 4,
          "course": 256,
          "odometer": 1816658
        },
        {
          "pos_time": "2020-09-15T05:16:01Z",
          "receivetime": "2020-09-15T05:16:08Z",
          "latitude": -34044538,
          "longitude": 20547974,
          "speed": 4,
          "course": 253,
          "odometer": 1816658
        },
        {
          "pos_time": "2020-09-15T05:16:04Z",
          "receivetime": "2020-09-15T05:16:08Z",
          "latitude": -34044537,
          "longitude": 20547942,
          "speed": 4,
          "course": 255,
          "odometer": 1816658
        },
        {
          "pos_time": "2020-09-15T05:16:07Z",
          "receivetime": "2020-09-15T05:16:08Z",
          "latitude": -34044538,
          "longitude": 20547909,
          "speed": 4,
          "course": 260,
          "odometer": 1816658
        },
        {
          "pos_time": "2020-09-15T05:16:10Z",
          "receivetime": "2020-09-15T05:16:23Z",
          "latitude": -34044544,
          "longitude": 20547872,
          "speed": 4,
          "course": 258,
          "odometer": 1816658
        },
        {
          "pos_time": "2020-09-15T05:16:13Z",
          "receivetime": "2020-09-15T05:16:23Z",
          "latitude": -34044551,
          "longitude": 20547836,
          "speed": 4,
          "course": 254,
          "odometer": 1816658
        },
        {
          "pos_time": "2020-09-15T05:16:16Z",
          "receivetime": "2020-09-15T05:16:23Z",
          "latitude": -34044554,
          "longitude": 20547800,
          "speed": 4,
          "course": 264,
          "odometer": 1816658
        },
        {
          "pos_time": "2020-09-15T05:16:19Z",
          "receivetime": "2020-09-15T05:16:23Z",
          "latitude": -34044555,
          "longitude": 20547764,
          "speed": 4,
          "course": 269,
          "odometer": 1816658
        },
        {
          "pos_time": "2020-09-15T05:16:22Z",
          "receivetime": "2020-09-15T05:16:23Z",
          "latitude": -34044560,
          "longitude": 20547727,
          "speed": 4,
          "course": 261,
          "odometer": 1816658
        },
        {
          "pos_time": "2020-09-15T05:16:25Z",
          "receivetime": "2020-09-15T05:16:38Z",
          "latitude": -34044568,
          "longitude": 20547693,
          "speed": 4,
          "course": 256,
          "odometer": 1816709
        },
        {
          "pos_time": "2020-09-15T05:16:28Z",
          "receivetime": "2020-09-15T05:16:38Z",
          "latitude": -34044577,
          "longitude": 20547660,
          "speed": 4,
          "course": 254,
          "odometer": 1816709
        },
        {
          "pos_time": "2020-09-15T05:16:31Z",
          "receivetime": "2020-09-15T05:16:38Z",
          "latitude": -34044582,
          "longitude": 20547628,
          "speed": 4,
          "course": 256,
          "odometer": 1816709
        },
        {
          "pos_time": "2020-09-15T05:16:34Z",
          "receivetime": "2020-09-15T05:16:38Z",
          "latitude": -34044591,
          "longitude": 20547593,
          "speed": 4,
          "course": 255,
          "odometer": 1816709
        },
        {
          "pos_time": "2020-09-15T05:16:37Z",
          "receivetime": "2020-09-15T05:16:38Z",
          "latitude": -34044600,
          "longitude": 20547557,
          "speed": 4,
          "course": 256,
          "odometer": 1816709
        },
        {
          "pos_time": "2020-09-15T05:16:40Z",
          "receivetime": "2020-09-15T05:16:53Z",
          "latitude": -34044605,
          "longitude": 20547521,
          "speed": 4,
          "course": 255,
          "odometer": 1816709
        },
        {
          "pos_time": "2020-09-15T05:16:43Z",
          "receivetime": "2020-09-15T05:16:53Z",
          "latitude": -34044612,
          "longitude": 20547488,
          "speed": 4,
          "course": 255,
          "odometer": 1816709
        },
        {
          "pos_time": "2020-09-15T05:16:46Z",
          "receivetime": "2020-09-15T05:16:53Z",
          "latitude": -34044622,
          "longitude": 20547451,
          "speed": 4,
          "course": 253,
          "odometer": 1816709
        },
        {
          "pos_time": "2020-09-15T05:16:49Z",
          "receivetime": "2020-09-15T05:16:53Z",
          "latitude": -34044630,
          "longitude": 20547414,
          "speed": 4,
          "course": 262,
          "odometer": 1816709
        },
        {
          "pos_time": "2020-09-15T05:16:52Z",
          "receivetime": "2020-09-15T05:16:53Z",
          "latitude": -34044633,
          "longitude": 20547377,
          "speed": 4,
          "course": 262,
          "odometer": 1816709
        },
        {
          "pos_time": "2020-09-15T05:16:55Z",
          "receivetime": "2020-09-15T05:17:08Z",
          "latitude": -34044642,
          "longitude": 20547344,
          "speed": 4,
          "course": 249,
          "odometer": 1816709
        },
        {
          "pos_time": "2020-09-15T05:16:58Z",
          "receivetime": "2020-09-15T05:17:08Z",
          "latitude": -34044651,
          "longitude": 20547310,
          "speed": 4,
          "course": 251,
          "odometer": 1816709
        },
        {
          "pos_time": "2020-09-15T05:17:01Z",
          "receivetime": "2020-09-15T05:17:08Z",
          "latitude": -34044660,
          "longitude": 20547274,
          "speed": 4,
          "course": 254,
          "odometer": 1816709
        },
        {
          "pos_time": "2020-09-15T05:17:04Z",
          "receivetime": "2020-09-15T05:17:08Z",
          "latitude": -34044665,
          "longitude": 20547239,
          "speed": 4,
          "course": 257,
          "odometer": 1816709
        },
        {
          "pos_time": "2020-09-15T05:17:07Z",
          "receivetime": "2020-09-15T05:17:08Z",
          "latitude": -34044670,
          "longitude": 20547205,
          "speed": 4,
          "course": 258,
          "odometer": 1816709
        },
        {
          "pos_time": "2020-09-15T05:17:10Z",
          "receivetime": "2020-09-15T05:17:23Z",
          "latitude": -34044676,
          "longitude": 20547170,
          "speed": 4,
          "course": 255,
          "odometer": 1816759
        },
        {
          "pos_time": "2020-09-15T05:17:13Z",
          "receivetime": "2020-09-15T05:17:23Z",
          "latitude": -34044683,
          "longitude": 20547135,
          "speed": 4,
          "course": 256,
          "odometer": 1816759
        },
        {
          "pos_time": "2020-09-15T05:17:16Z",
          "receivetime": "2020-09-15T05:17:23Z",
          "latitude": -34044691,
          "longitude": 20547099,
          "speed": 4,
          "course": 259,
          "odometer": 1816759
        },
        {
          "pos_time": "2020-09-15T05:17:19Z",
          "receivetime": "2020-09-15T05:17:23Z",
          "latitude": -34044697,
          "longitude": 20547061,
          "speed": 4,
          "course": 259,
          "odometer": 1816759
        },
        {
          "pos_time": "2020-09-15T05:17:22Z",
          "receivetime": "2020-09-15T05:17:23Z",
          "latitude": -34044704,
          "longitude": 20547026,
          "speed": 4,
          "course": 257,
          "odometer": 1816759
        },
        {
          "pos_time": "2020-09-15T05:17:25Z",
          "receivetime": "2020-09-15T05:17:38Z",
          "latitude": -34044710,
          "longitude": 20546992,
          "speed": 4,
          "course": 262,
          "odometer": 1816759
        },
        {
          "pos_time": "2020-09-15T05:17:28Z",
          "receivetime": "2020-09-15T05:17:38Z",
          "latitude": -34044715,
          "longitude": 20546959,
          "speed": 4,
          "course": 258,
          "odometer": 1816759
        },
        {
          "pos_time": "2020-09-15T05:17:31Z",
          "receivetime": "2020-09-15T05:17:38Z",
          "latitude": -34044719,
          "longitude": 20546926,
          "speed": 4,
          "course": 262,
          "odometer": 1816759
        },
        {
          "pos_time": "2020-09-15T05:17:34Z",
          "receivetime": "2020-09-15T05:17:38Z",
          "latitude": -34044724,
          "longitude": 20546892,
          "speed": 4,
          "course": 257,
          "odometer": 1816759
        },
        {
          "pos_time": "2020-09-15T05:17:37Z",
          "receivetime": "2020-09-15T05:17:38Z",
          "latitude": -34044730,
          "longitude": 20546860,
          "speed": 4,
          "course": 256,
          "odometer": 1816759
        },
        {
          "pos_time": "2020-09-15T05:17:40Z",
          "receivetime": "2020-09-15T05:17:53Z",
          "latitude": -34044736,
          "longitude": 20546822,
          "speed": 4,
          "course": 262,
          "odometer": 1816759
        },
        {
          "pos_time": "2020-09-15T05:17:43Z",
          "receivetime": "2020-09-15T05:17:53Z",
          "latitude": -34044743,
          "longitude": 20546789,
          "speed": 4,
          "course": 251,
          "odometer": 1816759
        },
        {
          "pos_time": "2020-09-15T05:17:46Z",
          "receivetime": "2020-09-15T05:17:53Z",
          "latitude": -34044751,
          "longitude": 20546758,
          "speed": 4,
          "course": 249,
          "odometer": 1816759
        },
        {
          "pos_time": "2020-09-15T05:17:49Z",
          "receivetime": "2020-09-15T05:17:53Z",
          "latitude": -34044756,
          "longitude": 20546724,
          "speed": 4,
          "course": 255,
          "odometer": 1816759
        },
        {
          "pos_time": "2020-09-15T05:17:52Z",
          "receivetime": "2020-09-15T05:17:53Z",
          "latitude": -34044766,
          "longitude": 20546685,
          "speed": 4,
          "course": 256,
          "odometer": 1816759
        },
        {
          "pos_time": "2020-09-15T05:17:55Z",
          "receivetime": "2020-09-15T05:18:08Z",
          "latitude": -34044775,
          "longitude": 20546647,
          "speed": 4,
          "course": 256,
          "odometer": 1816759
        },
        {
          "pos_time": "2020-09-15T05:17:58Z",
          "receivetime": "2020-09-15T05:18:08Z",
          "latitude": -34044783,
          "longitude": 20546611,
          "speed": 4,
          "course": 257,
          "odometer": 1816810
        },
        {
          "pos_time": "2020-09-15T05:18:01Z",
          "receivetime": "2020-09-15T05:18:08Z",
          "latitude": -34044785,
          "longitude": 20546575,
          "speed": 4,
          "course": 262,
          "odometer": 1816810
        },
        {
          "pos_time": "2020-09-15T05:18:04Z",
          "receivetime": "2020-09-15T05:18:08Z",
          "latitude": -34044791,
          "longitude": 20546539,
          "speed": 4,
          "course": 259,
          "odometer": 1816810
        },
        {
          "pos_time": "2020-09-15T05:18:07Z",
          "receivetime": "2020-09-15T05:18:08Z",
          "latitude": -34044799,
          "longitude": 20546503,
          "speed": 4,
          "course": 252,
          "odometer": 1816810
        },
        {
          "pos_time": "2020-09-15T05:18:10Z",
          "receivetime": "2020-09-15T05:18:23Z",
          "latitude": -34044810,
          "longitude": 20546470,
          "speed": 4,
          "course": 250,
          "odometer": 1816810
        },
        {
          "pos_time": "2020-09-15T05:18:13Z",
          "receivetime": "2020-09-15T05:18:23Z",
          "latitude": -34044821,
          "longitude": 20546437,
          "speed": 4,
          "course": 243,
          "odometer": 1816810
        },
        {
          "pos_time": "2020-09-15T05:18:16Z",
          "receivetime": "2020-09-15T05:18:23Z",
          "latitude": -34044829,
          "longitude": 20546406,
          "speed": 4,
          "course": 245,
          "odometer": 1816810
        },
        {
          "pos_time": "2020-09-15T05:18:19Z",
          "receivetime": "2020-09-15T05:18:23Z",
          "latitude": -34044835,
          "longitude": 20546369,
          "speed": 4,
          "course": 255,
          "odometer": 1816810
        },
        {
          "pos_time": "2020-09-15T05:18:22Z",
          "receivetime": "2020-09-15T05:18:23Z",
          "latitude": -34044840,
          "longitude": 20546330,
          "speed": 4,
          "course": 259,
          "odometer": 1816810
        },
        {
          "pos_time": "2020-09-15T05:18:25Z",
          "receivetime": "2020-09-15T05:18:38Z",
          "latitude": -34044844,
          "longitude": 20546295,
          "speed": 4,
          "course": 262,
          "odometer": 1816810
        },
        {
          "pos_time": "2020-09-15T05:18:28Z",
          "receivetime": "2020-09-15T05:18:38Z",
          "latitude": -34044847,
          "longitude": 20546260,
          "speed": 4,
          "course": 261,
          "odometer": 1816810
        },
        {
          "pos_time": "2020-09-15T05:18:31Z",
          "receivetime": "2020-09-15T05:18:38Z",
          "latitude": -34044853,
          "longitude": 20546222,
          "speed": 4,
          "course": 261,
          "odometer": 1816810
        },
        {
          "pos_time": "2020-09-15T05:18:34Z",
          "receivetime": "2020-09-15T05:18:38Z",
          "latitude": -34044858,
          "longitude": 20546189,
          "speed": 4,
          "course": 256,
          "odometer": 1816810
        },
        {
          "pos_time": "2020-09-15T05:18:37Z",
          "receivetime": "2020-09-15T05:18:38Z",
          "latitude": -34044865,
          "longitude": 20546156,
          "speed": 4,
          "course": 257,
          "odometer": 1816810
        },
        {
          "pos_time": "2020-09-15T05:18:40Z",
          "receivetime": "2020-09-15T05:18:54Z",
          "latitude": -34044872,
          "longitude": 20546121,
          "speed": 4,
          "course": 257,
          "odometer": 1816810
        },
        {
          "pos_time": "2020-09-15T05:18:43Z",
          "receivetime": "2020-09-15T05:18:54Z",
          "latitude": -34044879,
          "longitude": 20546085,
          "speed": 4,
          "course": 257,
          "odometer": 1816861
        },
        {
          "pos_time": "2020-09-15T05:18:46Z",
          "receivetime": "2020-09-15T05:18:54Z",
          "latitude": -34044883,
          "longitude": 20546052,
          "speed": 4,
          "course": 259,
          "odometer": 1816861
        },
        {
          "pos_time": "2020-09-15T05:18:49Z",
          "receivetime": "2020-09-15T05:18:54Z",
          "latitude": -34044888,
          "longitude": 20546017,
          "speed": 4,
          "course": 261,
          "odometer": 1816861,
          "country": "ZA"
        },
        {
          "pos_time": "2020-09-15T05:18:52Z",
          "receivetime": "2020-09-15T05:18:54Z",
          "latitude": -34044900,
          "longitude": 20545982,
          "speed": 4,
          "course": 257,
          "odometer": 1816861,
          "country": "ZA"
        },
        {
          "pos_time": "2020-09-15T05:18:55Z",
          "receivetime": "2020-09-15T05:19:09Z",
          "latitude": -34044903,
          "longitude": 20545952,
          "speed": 3,
          "course": 266,
          "odometer": 1816861,
          "country": "ZA"
        },
        {
          "pos_time": "2020-09-15T05:18:58Z",
          "receivetime": "2020-09-15T05:19:09Z",
          "latitude": -34044904,
          "longitude": 20545915,
          "speed": 4,
          "course": 263,
          "odometer": 1816861,
          "country": "ZA"
        },
        {
          "pos_time": "2020-09-15T05:19:01Z",
          "receivetime": "2020-09-15T05:19:09Z",
          "latitude": -34044914,
          "longitude": 20545882,
          "speed": 5,
          "course": 248,
          "odometer": 1816861,
          "country": "ZA"
        },
        {
          "pos_time": "2020-09-15T05:19:04Z",
          "receivetime": "2020-09-15T05:19:09Z",
          "latitude": -34044925,
          "longitude": 20545853,
          "speed": 3,
          "course": 241,
          "odometer": 1816861,
          "country": "ZA"
        },
        {
          "pos_time": "2020-09-15T05:19:07Z",
          "receivetime": "2020-09-15T05:19:09Z",
          "latitude": -34044944,
          "longitude": 20545823,
          "speed": 4,
          "course": 234,
          "odometer": 1816861,
          "country": "ZA"
        },
        {
          "pos_time": "2020-09-15T05:19:10Z",
          "receivetime": "2020-09-15T05:19:23Z",
          "latitude": -34044967,
          "longitude": 20545794,
          "speed": 4,
          "course": 227,
          "odometer": 1816861,
          "country": "ZA"
        },
        {
          "pos_time": "2020-09-15T05:19:13Z",
          "receivetime": "2020-09-15T05:19:23Z",
          "latitude": -34044994,
          "longitude": 20545768,
          "speed": 4,
          "course": 218,
          "odometer": 1816861,
          "country": "ZA"
        },
        {
          "pos_time": "2020-09-15T05:19:16Z",
          "receivetime": "2020-09-15T05:19:23Z",
          "latitude": -34045019,
          "longitude": 20545746,
          "speed": 4,
          "course": 212,
          "odometer": 1816861,
          "country": "ZA"
        }
      ]
    }
  },

  methods: {
    openDetailModal (row) {
      this.showDetailModal = true
    }
  }
}
</script>